import { sendParameters } from '../../../common/functions'
import TaskWrapper from './TaskWrapper'

export default function AdditionalCalculationCheckWidget({ task, isCanceled }) {
  return (
    <TaskWrapper
      task={task}
      label="Проверка обновленной калькуляции"
      isCanceled={isCanceled}
      onSave={() => sendParameters(task.paidServiceId, task.id, {}, [])}
      saveButtonLabel="Проверено"
    />
  )
}
